// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  IngestionStatus,
} from "./types";


export default __t.row({
  requestId: __t.u128().primaryKey().name("request_id"),
  requestedBy: __t.identity().name("requested_by"),
  get status() {
    return IngestionStatus;
  },
  sourceUrl: __t.string().name("source_url"),
  targetModule: __t.string().name("target_module"),
  format: __t.string(),
  scope: __t.string(),
  createdAt: __t.timestamp().name("created_at"),
  updatedAt: __t.timestamp().name("updated_at"),
  error: __t.option(__t.string()),
  converter: __t.option(__t.string()),
  assetId: __t.u64().name("asset_id"),
  sourceRenditionId: __t.u64().name("source_rendition_id"),
  operation: __t.option(__t.string()),
  jobDurationSecs: __t.u64().name("job_duration_secs"),
  geoOrigin: __t.option(__t.string()).name("geo_origin"),
  progressStage: __t.option(__t.string()).name("progress_stage"),
  progressPct: __t.option(__t.f32()).name("progress_pct"),
});
